import type * as ConcurrentStreamCheckBundle from '@foundation-player/plugin-concurrent-stream-check';
import { PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createConcurrentStreamCheckPlugin: PluginFactoryFunction = (builderConfig) => {
  const concurrentStreamCheckPackage = PackageName.PluginConcurrentStreamCheck;

  return [
    [concurrentStreamCheckPackage],
    () => {
      const concurrentStreamCheckGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[concurrentStreamCheckPackage];

      return [
        new (resolveByPackageNameOrThrow<typeof ConcurrentStreamCheckBundle>(
          concurrentStreamCheckPackage,
        ).ConcurrentStreamCheckPlugin)(
          builderConfig.pluginConfigs[concurrentStreamCheckGlobalName] as ConcurrentStreamCheckBundle.PluginConfig,
        ),
      ];
    },
  ];
};
